export const errorImagePath = () => `${import.meta.env.VITE_PUBLIC_URL}/static/enablers/icons/ErrorIllustration.svg`;
